<template>
  <section class="_menu-section-style">
    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        textType="title"
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>

    <form-section label="Itens" v-model="isExpanded.items">
      <v-row no-gutters>
        <v-col cols="6" class="_pr-">
          <Select 
          label="Máximo de colunas"
          v-model="selectedSection['max-columns']" 
          :items="columnsOptions" 
          :showBorder="true"
          />
        </v-col>        
        <v-col cols="6" class="_pl-">
          <ColorPickerV2 :colorSelected="selectedSection" type="accent-color" title="Cor dos números"/>   
        </v-col>        
      </v-row>
    </form-section>

    <form-section label="Números" v-model="isExpanded.numbers" :divider="false">
      <NumberOptions :sectionsId="sectionsId" :selectedSection="selectedSection"/>
    </form-section>
  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import Select from '../../_v2/ui/Select.vue'
import NumberOptions from '../forms/formsV2/NumberOptions.vue'

export default {
  name: 'NumberSection',
  components: { FormSection, Texts, Background, ColorPickerV2, Select, NumberOptions},
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },

  data: () => ({
    isExpanded: {title: true, subtitle: true, bg: true, items: true, numbers: true},
    columnsOptions: [2, 3, 4]  
  }),

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    }
  }    
}
</script>

<style scoped>
</style>